export default class UI {
  /**
   * 
   * @param {import('../Api.js').default} api 
   */
  constructor( api ) {
    this.api = api
  }

  pendingRelease() {
    const conn = this.api.child( 'pendingRelease' )

    return {
      get : conn.get
    }
  }
}
